// extracted by mini-css-extract-plugin
export default {"contrainer":"styles_contrainer__63Jpk"};